<template>
  <transition name="fade">
    <div class="menu">
      Oh noes! You're out of taps.
      <h1>{{score}}</h1>
      <button @click="$emit('retry')">Try again</button>
      <button v-if="runningInApp && !alreadyRewarded" @click="getExtraClicks">
        <i class="fa fa-film" aria-hidden="true"></i> Get extra taps!</button>
      <router-link :to="{'name': 'start'}" class="button blue" replace>Main menu</router-link>
      <div class="ads">
        <ins class="adsbygoogle" style="display:block" data-ad-client="ca-pub-9072364747594224" data-ad-slot="3124355986" data-ad-format="auto"></ins>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'retryMenu',
  props: {
    score: [String, Number],
    alreadyRewarded: Boolean,
    runningInApp: Boolean,
  },
  data() {
    return {};
  },
  created() {
    console.log('this.runningInApp', this.runningInApp, window.Android, window.webkit);
    if (this.runningInApp) {
      window.addEventListener('message', this.doSomeShit);
    }
  },
  beforeDestroy() {
    if (this.runningInApp) {
      window.removeEventListener('message', this.doSomeShit);
    }
  },
  mounted() {
    if (!this.runningInApp) {
      (adsbygoogle = window.adsbygoogle || []).push({}); //eslint-disable-line
    }
  },
  methods: {
    doSomeShit(e) {
      console.log('does message match', e.origin === location.origin, e.origin, location.origin);
      if (e.origin === location.origin) {
        if (e.data === 'rewarded') {
          this.$emit('reward');
        } else {
          this.$emit('retry');
        }
        console.log('get message from server retry meny', e);
      }
    },
    getExtraClicks() {
      if (window.webkit) {
        try {
          window.webkit.messageHandlers.callbackHandler.postMessage('Hello from JavaScript');
        } catch (err) {
          console.log('The native context does not exist yet');
        }
      }

      if (window.Android) {
        try {
          window.Android.getExtraClicks();
        } catch (err) {
          console.log('The native context does not exist yet');
        }
      }
    },
  },
};
</script>

<style lang="less">
.menu {
  visibility: hidden;
  &.fade-enter-active,
  {
    transition: all ease .3s .5s;
  }

  &.fade-leave-active {
    transition: all ease .3s;
  }

  &.fade-enter-to {
    visibility: visible;
  }

  &.fade-enter,
  &.fade-leave-to
  /* .fade-leave-active in <2.1.8 */
  {
    opacity: 0;
    visibility: hidden;
  }
  .ads {
    // position: absolute;
    // bottom: 0;
    // left: 0;
    // right: 0;
    padding-top: 1rem;
    height: auto;
    width: 100%;
    font-size: .75rem;
  }
}
</style>



// WEBPACK FOOTER //
// RetryMenu.vue?30cf9aeb